import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorNotificationSearch = () => {
  const notificationSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/communication-notification/search', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        }
      }
      loading(false)
    })
  }, [])
  return { notificationSearch }
}

export default InteractorNotificationSearch
